<template>
  <section v-if="!window.PHP.bot || isPromoCodeDetails" :class="{ 'mt-3 mb-6': !isPromoCodeDetails }">
    <div class="relative rounded-zt h-[109px] flex flex-col justify-center items-start pl-3 xl:items-center xl:pl-0"
         :class="isPromoCodeDetails ? 'bg-zt-dark cursor-pointer zt-hover' : 'border border-zt-light bg-zt-light/35'"
         @click="handleClick">
      <svg v-if="window.size.desktop" class="absolute left-0 top-0" width="99" height="100" viewBox="0 0 99 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.2">
          <path d="M 63.2 98.7 L 7.9 43.5 L 7.9 8.9 L 42.4 8.9 L 97.7 64.2 L 63.2 98.7 Z" stroke="#93A3BA" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M 32.1 26.2 C 32.1 22.4 29 19.3 25.2 19.3 C 21.4 19.3 18.3 22.4 18.3 26.2 C 18.3 30 21.4 33.1 25.2 33.1 C 29 33.1 32.1 30 32.1 26.2 Z" stroke="#93A3BA" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M 21.7 22.7 L 1 2" stroke="#93A3BA" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M 32.1 46.9 L 59.7 74.5" stroke="#93A3BA" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M 45.9 33.1 L 59.7 46.9" stroke="#93A3BA" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        </g>
      </svg>
      <div class="flex flex-col items-center">
        <span v-if="!isPromoCodeDetails" class="uppercase text-lg font-medium text-white mt-1 xl:mt-2">{{ promoCodeHeaderFromAttr }}</span>
        <span class="uppercase text-[40px] font-semibold text-zt-red"><span class="text-white">&bdquo;</span>{{ promoCode }}<span class="text-white pl-1">&rdquo;</span></span>
      </div>
      <svg class="absolute rotate-90 right-0 top-0" width="99" height="100" viewBox="0 0 99 100" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.2">
          <path d="M 63.2 98.7 L 7.9 43.5 L 7.9 8.9 L 42.4 8.9 L 97.7 64.2 L 63.2 98.7 Z" stroke="#93A3BA" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M 32.1 26.2 C 32.1 22.4 29 19.3 25.2 19.3 C 21.4 19.3 18.3 22.4 18.3 26.2 C 18.3 30 21.4 33.1 25.2 33.1 C 29 33.1 32.1 30 32.1 26.2 Z" stroke="#93A3BA" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M 21.7 22.7 L 1 2" stroke="#93A3BA" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M 32.1 46.9 L 59.7 74.5" stroke="#93A3BA" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M 45.9 33.1 L 59.7 46.9" stroke="#93A3BA" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
        </g>
      </svg>
    </div>
  </section>
</template>

<script>
import utils_mixin from '../../mixins/utils_mixin';

export default {
  name: 'PromoCodeBox',
  mixins: [utils_mixin],
  props: {
    promoCodeHeaderFromProps: String,
    promoCodeFromProps: String,
    isPromoCodeDetails: Boolean,
    bonusLink: String
  },
  data() {
    return {
      promoCodeHeaderFromAttr: this.$attrs.header ?? '',
      promoCodeFromAttr: this.$attrs.kod ?? ''
    };
  },
  computed: {
    promoCode() {
      if (this.isPromoCodeDetails) {
        return this.promoCodeFromProps;
      } else {
        return this.promoCodeFromAttr;
      }
    }
  },
  methods: {
    handleClick() {
      if (this.isPromoCodeDetails) {
        window.open(this.bonusLink, '_blank');
				this.countClicks('Kody promocyjne - 1');
      }
    }
  }
};
</script>
